import React from 'react';
import {Modal, Button} from 'semantic-ui-react';

const ModalComfirm = ({handleModal, open, handleNotification}) => {
  return (
    <Modal size='mini' open={open}>
      <Modal.Header>Enviar notificación</Modal.Header>
      <Modal.Content>
      ¿ Esta seguro de enviar la notificación ? . Luego de notificar no se podra editar
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleModal}>
          Cerrar
        </Button>
        <Button onClick={handleNotification} color='green'>
          Notificar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ModalComfirm;
